import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import UserDataSource from "../UserDataSource";
import { UserAPIEntity } from "./Entity/UserAPIEntity";
import { UsersAPIEntity } from "./Entity/UsersAPIEntity";
import { UserStateAPIEntity } from "./Entity/UserStateAPIEntity";

const routeName = `/v1/users`;

export default class UserAPIDataSourceImpl implements UserDataSource {
    
    async getUsers(page: number, pageSize: number, search: string): Promise<PaginationResult<UsersAPIEntity>> {
        const SortOrder = "desc";
        try {
            const response = await api.get<ApiResponse<any>>(routeName, {
                params: { page, pageSize, search, SortOrder }
            });
    
            const data = response.data.data;
    
            if (data && Array.isArray(data.items)) {
                const users: UsersAPIEntity[] = data.items.map((item: UsersAPIEntity) => ({
                id: item.id,
                firstName: item.firstName,
                lastName: item.lastName,
                email: item.email,
                role: item.role,
                created: item.created,
                status: item.status,
                }));
        
                return {
                items: users,
                page: data.page,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                hasNextPage: data.hasNextPage,
                hasPreviousPage: data.hasPreviousPage,
                };
            } else {
                throw new Error("La respuesta no tiene el formato esperado");
            }
        } catch (error) {
            console.error("Error al obtener los productos:", error);
            throw new Error("Error al obtener los productos");
        }
    }
    
    async createusers(data: UserAPIEntity): Promise<boolean> {
        try {
        // Define los datos que deseas enviar en la petición POST
        const postData = {
            firstName: data.firstName,
            lastName: data.lastName,
            dni: data.dni,
            // gender: data.gender,
            email: data.email,
            role: data.role,
        };
        
        // Realiza la petición POST utilizando axios
        const response = await api.post<ApiResponse<any>>(routeName, postData);
        
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true && response.data?.data) {

            return response.data.data;
        } else {
            // Maneja el caso en el que la respuesta no tiene el formato esperado
            throw new Error("La respuesta no tiene el formato esperado o falta el ID del producto.");
        }
        } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agragar el producto:", error);
        throw new Error("Error al agragar el producto");
        }
    }
    async updateStateUser(data: UserStateAPIEntity): Promise<boolean> {
        try {
            // Realiza la petición PUT utilizando axios
            const response = await api.post<ApiResponse<any>>(`${routeName}/update-status`, data);
        
            // Verifica si la respuesta contiene datos
            if (response.data?.succeeded) {
                // Devuelve true si la actualización fue exitosa
                return true;
            } else {
                console.warn("La API respondió con un formato inesperado:", response.data);
                return false;
            }
        } catch (error: any) {
            // Si hay error en la respuesta, intentamos obtener detalles
            if (error.response) {
            console.error(`Error ${error.response.status}:`, error.response.data);
            } else {
            console.error("Error de red o de servidor:", error.message);
            }
            return false; // Retornamos false en lugar de lanzar una excepción
        }
    }
    removeUser(id: string): Promise<boolean> {
        throw new Error("Method not implemented.");
    }
    updateUser(data: UserAPIEntity): Promise<boolean> {
        throw new Error("Method not implemented.");
    }

}